"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Join = require("./Join");
Object.keys(_Join).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Join[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Join[key];
    }
  });
});